import { useEffect, useState } from "react";

export default function DisclaimerModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const acknowledged = sessionStorage.getItem("disclaimer_acknowledged");
    if (!acknowledged) {
      setShow(true);
    }
  }, []);

  const handleUnderstand = () => {
    sessionStorage.setItem("disclaimer_acknowledged", "true");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-slate-900/90 backdrop-blur-sm">
      <div className="mx-4 w-full max-w-lg rounded-2xl bg-white p-8 text-center shadow-2xl">
        <h2 className="mb-4 text-2xl font-semibold text-slate-900">Website Disclaimer</h2>
        <p className="mb-6 text-sm leading-relaxed text-slate-700">
          This website is for <strong>illustrative and educational purposes only</strong>. The content,
          images, and materials presented here do not represent a real company or any actual financial
          institution. Nothing on this site should be construed as financial, legal, or investment
          advice.
          <br />
          <br />
          All examples are fictitious and used solely to demonstrate potential design, layout, or
          informational concepts.
          <br />
          <br />
          By clicking <strong>&quot;I Understand&quot;</strong>, you acknowledge that you are viewing a demonstration
          website for development purposes only.
        </p>

        <div className="mt-6 flex justify-center gap-4">
          <button
            type="button"
            onClick={handleUnderstand}
            className="rounded-lg bg-[#2B5288] px-5 py-2.5 font-medium text-white shadow-sm transition hover:opacity-90"
          >
            I Understand
          </button>
          <button
            type="button"
            onClick={() => {}}
            className="rounded-lg border border-slate-400 px-5 py-2.5 font-medium text-slate-700 transition hover:bg-slate-50"
          >
            I Don&apos;t Understand
          </button>
        </div>
      </div>
    </div>
  );
}
